import { Loader } from "Components/Loader";
import { PreOrderUnitListItem } from "Requests/PreOrder";
import { PrePreOrderListRow } from "./PrePreOrderListRow";

interface PrePreOrderListProps {
  items?: PreOrderUnitListItem[];
  loading: boolean;
}

const columns = [
  {
    title: "Telefone",
    key: "phone",
  },
  {
    title: "Nome",
    key: "name",
  },
  {
    title: "CPF",
    key: "cpf",
  },
  {
    title: "Tipo de atendimento",
    key: "attendance_type",
  },
  {
    title: "Data de abertura",
    key: "created_at",
  },
  {
    title: "Status de processamento",
    key: "status",
  },
  {
    title: "Ações",
    key: "actions",
    className: "text-center",
  },
];

export const PrePreOrderList = ({ items, loading }: PrePreOrderListProps) => {
  return (
    <table className="table-content details">
      <thead>
        <tr>
          {columns.map((column) => (
            <th
              key={column.key}
              {...(column.className && {
                className: column.className,
              })}
            >
              {column.title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {items &&
          items.length >= 1 &&
          items.map((item) => <PrePreOrderListRow item={item} key={item.id} />)}

        {items && items.length === 0 && (
          <tr>
            <td colSpan={7} className="text-center text-purple">
              Oops! Parece que nada foi encontrado...
            </td>
          </tr>
        )}

        {loading && (
          <tr>
            <td colSpan={7} className="text-center">
              <Loader />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
